import type { ButtonHTMLAttributes, ReactNode } from 'react';

/**
 * 온보딩 화면 공용 조각.
 * 버튼은 brand-700 바탕 — brand-500 위 흰 글씨는 대비 2.9:1 로 WCAG AA 에 못 미친다(700 은 5.0:1).
 */
export function PrimaryButton({
  className,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      {...rest}
      className={`w-full rounded-lg bg-brand-700 py-3 text-sm font-bold text-white transition-colors hover:bg-brand-800 disabled:cursor-not-allowed disabled:opacity-50 ${className ?? ''}`}
    />
  );
}

export function TextButton({
  className,
  type = 'button',
  ...rest
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      {...rest}
      className={`rounded-sm text-xs font-semibold text-brand-700 underline-offset-2 hover:underline disabled:cursor-not-allowed disabled:text-neutral-400 disabled:no-underline dark:text-brand-400 ${className ?? ''}`}
    />
  );
}

export function StepHeading({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) {
  return (
    <div className="mb-5">
      <h2 className="text-lg font-bold -tracking-[0.01em] text-neutral-950 dark:text-neutral-100">
        {title}
      </h2>
      {children && (
        <p className="mt-1 break-keep text-sm text-neutral-600 dark:text-neutral-400">
          {children}
        </p>
      )}
    </div>
  );
}

export function InlineError({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="break-keep text-xs text-danger">
      {children}
    </p>
  );
}
